import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Star from '../components/Star';
import ParameterErrors from '../errors/ParameterErrors';
import IconButtonNonReact from '../components/IconButtonNonReact';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import ResizeWatcher from '../ui_core/ResizeWatcher';
import PlotDetailedInformationSectionType from './PlotDetailedInformationSectionType';
const {throwNotProvided}=ParameterErrors;
export default class PlotDetailedInformationDescription {
	constructor(props){
		const { siteJsonUnitPlot}=props;
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._element = document.createElement('div');
		this._element.classList.add('description');
		this._innerElement = document.createElement('div');
		this._innerElement.classList.add('inner');
		this._element.appendChild(this._innerElement);
		this._innerElement.innerHTML = siteJsonUnitPlot.about;
	}
	set plot(siteJsonUnitPlot){
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._innerElement.innerHTML = siteJsonUnitPlot.about;
	}
	get element(){
		return this._element;
	}
	get sectionType(){
		return PlotDetailedInformationSectionType.Description;
	}
}